export default __webpack_public_path__ + "static/media/Close.3d6f4216.svg";